import { fetchInventoryRelocations, selectInventoryRelocation, resetCurrentInventoryRelocation } from '../../actions/inventoryRelocations_actions';
import { resetCurrentInventoryConvert } from '../../actions/inventoryConverts_actions';
import { connect } from 'react-redux';

import InventoryRelocations from '../../components/Inventories/inventoryRelocations'

function mapStateToProps(state) {
    return {
        inventoryRelocations: state.inventoryRelocations.all,
        isLoading: state.inventoryRelocations.isLoading,
        error: state.inventoryRelocations.error,
        currentInventoryRelocation: state.inventoryRelocations.currentInventoryRelocation,
        userPermissions: state.auth.userPermissions
    };
}

export default connect(mapStateToProps, { resetCurrentInventoryConvert, fetchInventoryRelocations, selectInventoryRelocation, resetCurrentInventoryRelocation })(InventoryRelocations);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/inventoryRelocations.jsx